"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getPkgSlice = exports.getOtherWidgetSlice = exports.getLoadingState = exports.getLanguage = exports.getError = exports.getAllCampaigns = exports.configSelector = void 0;
var _appConstants = require("../appConstants");
var configSelector = function configSelector(state) {
  var _state$config, _state$config$data;
  var myWidget = (_state$config = state.config) === null || _state$config === void 0 ? void 0 : (_state$config$data = _state$config.data) === null || _state$config$data === void 0 ? void 0 : _state$config$data.widgets[_appConstants.pkgName];
  if (myWidget) {
    var _state$pkgName;
    var insID = (_state$pkgName = state[_appConstants.pkgName]) === null || _state$pkgName === void 0 ? void 0 : _state$pkgName.instanceId;
    return myWidget[insID];
  }
  return null;
};
exports.configSelector = configSelector;
var getPkgSlice = function getPkgSlice(state) {
  return state[_appConstants.pkgName];
};
exports.getPkgSlice = getPkgSlice;
var getLanguage = function getLanguage(state) {
  var _state$language;
  return (state === null || state === void 0 ? void 0 : (_state$language = state.language) === null || _state$language === void 0 ? void 0 : _state$language.language) || 'en';
};
exports.getLanguage = getLanguage;
var getOtherWidgetSlice = function getOtherWidgetSlice(widget) {
  return function (state) {
    return state[widget];
  };
};
exports.getOtherWidgetSlice = getOtherWidgetSlice;
var getAllCampaigns = function getAllCampaigns(state) {
  var _getPkgSlice;
  return (_getPkgSlice = getPkgSlice(state)) === null || _getPkgSlice === void 0 ? void 0 : _getPkgSlice.campaigns;
};
exports.getAllCampaigns = getAllCampaigns;
var getLoadingState = function getLoadingState(state) {
  var _getPkgSlice2;
  return (_getPkgSlice2 = getPkgSlice(state)) === null || _getPkgSlice2 === void 0 ? void 0 : _getPkgSlice2.loading;
};
exports.getLoadingState = getLoadingState;
var getError = function getError(state) {
  var _getPkgSlice3;
  return (_getPkgSlice3 = getPkgSlice(state)) === null || _getPkgSlice3 === void 0 ? void 0 : _getPkgSlice3.error;
};
exports.getError = getError;